const $ = window.$;
/*export const getText = (name) => {
    return $('input[name="' + name + '"]').val();
}
export const setText = (name, val) => {
    $('input[name="' + name + '"]').val(val);
}
export const setLabelText = (name, val) => {
    $('#label_' + name).html(val);
}
export const setFile = (name, val) => {
    if ($('input[name="' + name + '"]').parent().find('.link').length == 0) {
        $('<br/><a class="link" target="_blank" style="color:black;text-decoration: underline;" href="' + val.link + '">' + val.name + '</a>').insertAfter('input[name="' + name + '"]');
    }
}
export const setFile_link = (id, val) => {
    if ($('#' + id).parent().find('.link').length == 0) {
        $('<br/><a class="link" target="_blank" style="color:black;text-decoration: underline;" href="' + val.link + '">' + val.name + '</a>').insertAfter('#' + id);
    }
}
export const setHiddenText = (name, val) => {
    $('input:hidden[name="' + name + '"]').val(val);
}
export const setImage = (name, val) => {
    $('img#file_' + name).attr('src', val.link);
}
export const setLinkImage = (name, val) => {
    var extension = val.split('.').pop();
    if (extension == 'jpg' || extension == 'jpeg' || extension == 'png' || extension == 'gif') {
        $('img#file_' + name).attr('src', val).remove();
        if ($('img#file_' + name).length == 0) {
            $('<a class="link" target="_blank" href="' + val + '"><img id="file_' + name + '" width="150" style="margin-top: 15px;" src="' + val + '"/></a>').insertAfter('input[name="file_' + name + '"]');
        }
    } else {
        $('img#file_' + name).attr('src', val).remove();
        if ($('input[name="file_' + name + '"]').parent().find('.imagelink').length == 0) {
            $('<a class="imagelink" target="_blank" style="color:black;text-decoration: underline;" href="' + val + '">' + val + '</a>').insertAfter('input[name="file_' + name + '"]');
        }
    }
}
export const setDImage = (name, val) => {
    $('img#file_' + name).attr('src', val);
}
export const setSelect = (name, val) => {
    $('select[name="' + name + '"]').val(val);
}
export const getSelect = (name) => {
    return $('select[name="' + name + '"]').val();
}
export const setMultiSelect = (name, val) => {
    $('select[name="' + name + '"]').val(val);
    $('select[name="' + name + '"]').multiselect("refresh");
}
export const setTextArea = (name, val) => {
    $('textarea[name="' + name + '"]').val(val);
}
export const getTextArea = (name) => {
    return $('textarea[name="' + name + '"]').val();
}
export const getDateText = (name) => {
    return $('input[name="' + name + '"]').val();
}
export const setDateText = (name, val) => {
    $('input[name="' + name + '"]').val(val);
}
export const setKeywords = (name, val) => {
    var values = [];
    if (val.length > 0) {
        val.map((key, index) => {
            values.push(key.name);
        });
        $('textarea[name="' + name + '"]').val(values.toString());
    }
}*/
export const handleDoubleRadio = (event) => {

    var inputVal = [];
    var leastval = '';
    var mostval = '';
    $('input[name="' + event.target.getAttribute("data-id") + '_least"]').attr('disabled',false);
    $('input[name="' + event.target.getAttribute("data-id") + '_most"]').attr('disabled',false);

    var i = 1;
    $('input[name="' + event.target.getAttribute("data-id") + '_most"]').each(function () {
        if ($(this).prop("checked") == true) {
            inputVal.push('m'+ i);
            mostval = $(this).val();
        }

        i++;
        
    });
    i = 1;
    $('input[name="' + event.target.getAttribute("data-id") + '_least"]').each(function () {
        if ($(this).prop("checked") == true) {
            inputVal.push('l'+ i);
            leastval = $(this).val();
        }
        if(mostval == $(this).val()){
            $(this).attr('disabled',true);
        }
        i++;
    });
    $('input[name="' + event.target.getAttribute("data-id") + '_hidden"]').val(inputVal.join("-"));
    
}
export const validateTxtbox = (event) => {
    var charCode = (event.which) ? event.which : event.keyCode;
    if ($.inArray(charCode, [49,50,51,52,53,54,55]) >= 0) {
    }else{
        event.preventDefault();
    }
}
export const handleTextbox = (event) => {

    var txtval =  $('input[name="' + event.target.name + '_hidden"]').val();
    var curval = event.target.value;
    if(txtval){
       var txtarr = txtval.split('-');
       if ($.inArray(curval, txtarr) >= 0) {
        event.target.value = '';
       }
    }
   

    var inputVal = [];
    $('input[name="' + event.target.name + '"]').each(function () {
        if ($(this).val() !== "") {
            inputVal.push($(this).val());
        }
    });
    $('input[name="' + event.target.name + '_hidden"]').val(inputVal.join("-"));
    
   
}
export const handleCheckbox = (event) => {
    let checkedInputs = $('input[name="' + event.target.name + '"]:checked'),
        targetTag = $('input[name="' + event.target.name + '_hidden"]'),
        inputVal = [];
    if (targetTag.attr("data-max-option")) {
        let maxOption = parseInt(targetTag.attr("data-max-option"));
        if (maxOption !== 0 && checkedInputs.length > maxOption) {
            event.preventDefault();
            alert("You can't select more than " + maxOption + " options.");
            return false;
        }
    }
    checkedInputs.each(function () {
        inputVal.push($(this).val());
    });
    targetTag.val(inputVal.join(","));
}
export const handleRadio = (event) => {
    $('input[name="' + event.target.name + '_hidden"]').val(event.target.value);
}
export const handleSequence = (event) => {
    var inputVal = [];
    $('input[name="' + event.target.name + '"]').each(function () {
        if ($(this).val() !== "") {
            inputVal.push($(this).val());
        }
    });
    $('input[name="' + event.target.name + '_hidden"]').val(inputVal.join("-"));
}
export const handleFormErrors = (formErrors) => {
    $("div.error_reg").remove();
    $.each(formErrors, function (key, val) {
        if ($('[name="' + key + '"]')) {
            $('[name="' + key + '"]').after('<div class="error_reg"><font color="#cc0000">' + val + '</font></div>');
        }
    });
}
export const allowOnlyNumberInput = (event) => {
    var charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
    }
}
export const autoFocusNext = (event, parentEle) => {
    $(event.target).closest(parentEle).next().find('.auto-focus').focus();
}
export const isValidEmail = (str) => {
    var pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
    return pattern.test(str);
}
export const isMatchesEmail = (str) => {
    var pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z0-9]{2,9}\b$/i;
    return pattern.test(str);
}
export const getFormValues = (jsonList) => {
    jsonList.questions.map(function (qVal, qKey) {
        var inputValue = "";
        if ($.inArray(qVal.questionType, ["textbox", "textarea", "combo"]) >= 0) {
            inputValue = $("#" + qVal.questionId).val();
        } else if ($.inArray(qVal.questionType, ["radio", "checkbox"]) >= 0) {
            inputValue = $('input[name="' + qVal.questionId + '_hidden"]').val();
        }
        jsonList.questions[qKey].questionAnswer = inputValue;
    });
    return jsonList;
}
export const validateFile = (e) => {
    $("p.error").remove();
    let files = e.target.files,
        isValidated = true;
    if (!files || files === undefined) {
        isValidated = false;
        $(e.target).after('<p class="error">Please upgrade your browser to upload file(s)');
    } else {
        // Get the allowed file types
        let allowedTypes = ($(e.target).attr("data-valid-types") !== undefined) ? $(e.target).attr("data-valid-types").split(",") : [];
        // Get the individual file max size
        let eachMaxSize = ($(e.target).attr("data-each-max-limit") !== undefined) ? $(e.target).attr("data-each-max-limit") : 0;
        // Get the all file max size
        let allMaxSize = ($(e.target).attr("data-max-limit") !== undefined) ? $(e.target).attr("data-max-limit") : 0;
        let invalidType = 0,
            eachMaxSizeExceeded = 0,
            totalSize = 0;
        for (var i = 0; i < files.length; i++) {
            totalSize += files[i].size;
            if (eachMaxSize > 0 && eachMaxSize < files[i].size) {
                eachMaxSizeExceeded++;
            }
            let fSegments = files[i].name.split("."),
                ext = fSegments[fSegments.length - 1].toLowerCase();
            if (allowedTypes.length > 0 && $.inArray(ext, allowedTypes) < 0) {
                invalidType++;
            }
        }
        if (eachMaxSizeExceeded > 0) {
            isValidated = false;
            $(e.target).after('<p class="error">Please check the maximum file size limit.');
        } else if (invalidType > 0) {
            isValidated = false;
            $(e.target).after('<p class="error">Please choose valid file type.');
        } else if (allMaxSize > 0 && allMaxSize < totalSize) {
            isValidated = false;
            $(e.target).after('<p class="error">Please check the maximum file size limit.');
        }
    }
    if (isValidated === false) {
        $(e.target).val("");
    }
    return isValidated;
}
export const countWords = (event) => {
    //alert();
    let inputTag = $(event.target),
        inputValue = $.trim(inputTag.val()),
        wordSegments = inputValue.split(/\s+/),
        wordCount = (inputValue !== "") ? wordSegments.length : 0,
        noOfWord = parseInt(inputTag.attr("data-total-words"));
    // Remove the word exceed notify message
    $(".word-limit-note").remove();
    $('.balance-words, .typing-words').show();
    if (wordCount <= noOfWord) {
        var balWordsTag = inputTag.parent().find(".balance-words"),
            wordCountTag = inputTag.parent().find(".typing-words"),
            actualWordLen = noOfWord - wordCount;
        if (balWordsTag && wordCountTag) {
            balWordsTag.html("Remaining Words: " + actualWordLen);
            wordCountTag.html("Words Count: " + wordCount);
        }
    }
    if (wordCount > noOfWord) {
        $('<p class="error word-limit-note">You have exceeded the maximum word limit. Please rephrase the contents to fit within the word limit specified.</p>').insertAfter(inputTag);
        let tempWords = "";
        for (let i = 0; i < noOfWord; i++) {
            tempWords = tempWords + wordSegments[i] + " ";
        }
        tempWords = tempWords.replace(/(^\s*)|(\s*$)/gi, "");
        tempWords = tempWords.replace(/[ ]{2,}/gi, " ");
        tempWords = tempWords.replace(/\n /, "\n");
        inputTag.val(tempWords);
    }
}



// WEBPACK FOOTER //
// ./src/helpers/Fields.js